import React from "react";

interface StatusBadgeProps {
  status?: string | null;
}

/** Exact palette (name -> colors + display text) */
const STYLES: Record<
  string,
  { bg: string; text: string; outline: string; display: string }
> = {
  "on site": {
    bg: "#cfe8fc",
    text: "#276ada",
    outline: "#276ada",
    display: "On-Site",
  },
  "in transit": {
    // bg: "#ffe0b3",
    bg: "#e2e3e5",
    // text: "#fb8c00",
    text: "#383d41",
    outline: "#383d41",
    display: "In-Transit",
  },
  "with supplier": {
    bg: "#d2f5d2",
    text: "#368727",
    outline: "#368727",
    display: "With Supplier",
  },
  "scheduled drop off": {
    bg: "#f9f7d2",
    text: "#a3a200",
    outline: "#a3a200",
    display: "Scheduled Drop-off",
  },
  "pending dropoff": {
    bg: "#f9f7d2",
    // text: "#a3a200",
    text: "#818000",
    outline: "#a3a200",
    display: "Pending Drop-off",
  },
};

/** Handle hyphens/underscores/casing/synonyms */
const ALIASES: Record<string, string> = {
  "on-site": "on site",
  onsite: "on site",
  on_site: "on site",

  "in-transit": "in transit",
  in_transit: "in transit",
  intransit: "in transit",

  "with-supplier": "with supplier",
  with_supplier: "with supplier",

  "scheduled drop-off": "scheduled drop off",
  scheduled_dropoff: "scheduled drop off",
  scheduled_drop_off: "scheduled drop off",
  "sched drop off": "scheduled drop off",

  "pending-dropoff": "pending dropoff",
  pending_dropoff: "pending dropoff",
  pending_drop_off: "pending dropoff",
  "pending drop off": "pending dropoff",
};

function normalize(raw: string) {
  const s = raw.toLowerCase().replace(/[_-]+/g, " ").replace(/\s+/g, " ").trim();
  return ALIASES[s] ?? s;
}

/* -------- base chip style (matches Removalstatus) -------- */
const CHIP_BASE: React.CSSProperties = {
  display: "inline-block",
  padding: "3px 7px",
  borderRadius: "0.525rem",
  fontSize: "0.75rem",
  textAlign: "center",
  // lineHeight: 1.2,
};

export const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => {
  if (!status || !status.toString().trim()) return <span>—</span>;

  const key = normalize(status);
  const cfg = STYLES[key];
  if (!cfg) return <span>—</span>;

  const style: React.CSSProperties = {
    ...CHIP_BASE,
    backgroundColor: cfg.bg,
    color: cfg.text,
    border: "0.2px solid",
    borderColor: `${cfg.outline}50`,
    whiteSpace: "nowrap",
  };

  return <div style={style}>{cfg.display}</div>;
};

export default StatusBadge;







